const notalProductsList = [
    'SLS_129652', //FSH Order Form Pad 
    'SLS_129460', //FSH ECP Talk Track Card
    'SLS_129459', //ECP Core Visual Aid 
    'SLS_129710', //NVMC Detail Aid Brouchure
    'SLS_129712', //ALOFT Study
    'SLS_129711', //NVMC White Paper
    'SLS_129458', //AMD Progression Companion Laminate Sheet
    'SLS_133002', //Waiting Room Practice Poster
    'SLS_129462', //Treatment Room Practice Poster
    'SLS_129709', //Patient Brochure
    'SLS_133001', //Patient Brochure (Spanish) 
    'SLS_129651' //Amsler grid/FSH Tear Pad
]

export default notalProductsList;